import './grid.less';

import React from 'react';
import { observer } from 'mobx-react';
import { VariableSizeList } from 'react-window';
import b_ from 'b_';

import { GridStore } from 'controls/grid/gridStore';
import { ItemRenderer } from 'controls/grid/itemRenderer';
import { GridHeader } from 'controls/grid/gridHeader';
import { AntSpin } from 'controls/react/ant/antSpin';
import { GridDataEntry } from 'controls/grid/gridDataEntry';
import { AntAlert } from 'controls/react/ant/antAlert';
import { getStore, GridStoreHolder } from 'controls/grid/utils/getStore';
import { i18n } from 'core/localization';

const b = b_.with('ceeview-grid');

export const Grid = observer(<DataItem extends GridDataEntry>(props: { store: GridStoreHolder<DataItem> }) => {
	const store = getStore(props.store);

	React.useEffect(() => {
		if (!store) return;

		if (!store.initialRenderHappened) {
			store.initialRenderHappened = true;
		}
	}, [store, store?.initialRenderHappened]);

	if (!store || !store.initialRenderHappened) return null;

	const rootClassName = b({
		fit: store.config.fit !== false,
		transparent: store.config.customization?.styling?.transparent == true,
		theme: store.config.customization?.theme ?? 'default',
	});

	return (
		<div ref={store.setRootRef} className={rootClassName}>
			{/*todo move gridHeader as a fixed row of the list - then there will bo no need to sync scrolling */}
			{store.initialized && <GridHeader ref={store.headerRef} store={store} scrollable={true} />}
			{store.config.informationMessage && (
				<AntAlert
					className={b('information-message')}
					message={store.config.informationMessage}
					type={'info'}
					closable={true}
				/>
			)}
			<div className={b('wrapper')} ref={store.setWrapperRef}>
				{!store.dataProvider.initialized && store.dataProvider.showLoader && (
					<AntSpin spinning={true} centered={true} />
				)}

				{store.dataProvider.initialized &&
					store.dataProvider.visibleRowsCount == 0 &&
					!store.dataProvider.failToLoad && (
						<div
							className={b('no-data-message', { clickable: store.config.customization?.emptyMessageOnClick != null })}
							onClick={store.config.customization?.emptyMessageOnClick}
						>
							{store.remoteDataProvider?.responseMessage ??
								store.config.customization?.emptyMessage ??
								store.config.emptyMessage ??
								i18n('There is no data available')}
						</div>
					)}

				{store.dataProvider.failToLoad && (
					<div className={b('no-data-message')}>
						{store.config.onLoadErrorMessage ??
							store.remoteDataProvider?.responseMessage ??
							i18n('There is no data available')}
					</div>
				)}

				{store.initialized && store.dataProvider.initialized && store.dataProvider.visibleRowsCount != 0 && (
					<VariableSizeList<GridStore<DataItem>>
						height={store.height}
						ref={(v) => (store.listControl = v)}
						width={store.width}
						itemCount={store.dataProvider.scrollableRowsCount}
						itemData={store}
						innerRef={store.setListRef}
						itemSize={(i) => store.getRowHeight(i)}
						onItemsRendered={store.itemsRendered}
					>
						{ItemRenderer}
					</VariableSizeList>
				)}
			</div>
		</div>
	);
});
